// extracted by mini-css-extract-plugin
export default {"divBody":"style_divBody__uAnMl","iconWrap":"style_iconWrap__cOVqp","groupItemIcon":"style_groupItemIcon__zYvVs"};